<template>
  <div class="container-fluid mt-2">
    <h2>Ereigniss-Daten Flows</h2>
    <b-tabs class="mt-3">
      <b-tab title="BusinessFlows">
        <div role="toolbar" class="btn-toolbar justify-content-between mt-3">
          <div class="btn-group">
            <button class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
            <button class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
          </div>
          <button @click="addBFlow()" class="btn btn-primary">Hinzuf&uuml;gen</button>
        </div>
        <b-table @row-clicked="openFlow" class="mt-3" striped hover :items="rows" :fields="fields">
          <template v-slot:cell(action)="data">
            <font-awesome-icon @click="deleteFlow(data.item.id,data.index)" icon="trash"/>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Laufende Flows">
        <div role="toolbar" class="btn-toolbar justify-content-between mt-3">
          <button @click="updateRunning" class="btn btn-secondary"><font-awesome-icon icon="redo"/></button>
        </div>
        <b-table class="mt-3" striped hover :items="running" :fields="runfields">
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import router from '../../router'
import bflows from '@/modules/bflows.js'

export default {
  name: 'BusinessFlows',
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'lastRun', label: 'Ausgeführt'},
        { key: 'lastError', label: 'Fehler'},
        { key: 'action', label: 'Aktion' }
      ],
      runfields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'start', label: 'Startzeitpunkt' }
      ],
      rows: [],
      running: [],
      delid: false,
      delidx: -1,
    }
  },
  created: function() {
    var self = this;
    bflows.list(function(data) {
      self.rows = data;
    })
    this.updateRunning();
  },
  methods: {
    updateRunning() {
      var self = this;
      bflows.listrunning().then(function(data) {
        self.running = data.running;
      })
    },
    addBFlow: function() {
      router.push({name:'BFlowEditor',params: { flowid: 'new' }});
    },
    deleteFlow: function(id,idx) {
      this.delid = id;
      this.delidx = idx;
      console.log('del' + id + ' ' + idx);
    },
    openFlow: function(row) {
      if (this.delid && this.delid > 0 && this.delidx >= 0 && confirm('Möchten Sie den Business Flow (' + this.delid + ') wirklich löschen?')) {
        console.log('open with delete');
        var self = this;
        this.rows.splice(this.delidx,1);
        this.delidx = -1;
        bflows.delete(this,this.delid,function() {
          self.$bvToast.toast('Flow wurde gelöscht.',{title: 'BusinessFlows',variant: 'success'});
        })
        return;
      }
      router.push({name: 'BFlowEditor',params: { flowid: row.id }});
    }
  }
}
</script>
